import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { User } from "../../../models/user";
import { AxiosHttpClient } from "../../../services/AxiosHttpService";

type AuthContextType = {
  user: User | null;
  roles: string[];
  loading: boolean;
  refreshUserInfos: () => void; // Ajout de la fonction de rafraîchissement
};

const AuthContext = createContext<AuthContextType>({
  user: null,
  roles: [],
  loading: true,
  refreshUserInfos: () => {},
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [roles, setRoles] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const getUserInfos = useCallback(() => {
    setLoading(true);
    AxiosHttpClient.get<User>("api/v1/docuveritas/account/infos")
      .then((res) => {
        setUser(res);
        setRoles(res.roles || []);
      })
      .catch((error) => {
        console.error(
          "Erreur lors de la récupération des informations de l'utilisateur",
          error
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    getUserInfos();
  }, [getUserInfos]);

  return (
    <AuthContext.Provider
      value={{ user, roles, loading, refreshUserInfos: getUserInfos }}
    >
      {children}
    </AuthContext.Provider>
  );
};
